var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSewing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 43,
    viewBox: "0 0 64 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4354 15.9282H49.1021V24.6226H52.0764V26.7962H53.5636V24.6226H56.419L57.921 15.8703C59.661 15.566 60.9995 14.0879 60.9995 12.3056V6.50936C60.9995 4.50966 59.3339 2.88672 57.2816 2.88672H52.0764V0.713135H50.5892V2.88672H16.3841V0.713135H14.8969V2.88672H9.69181C7.63951 2.88672 5.97386 4.50966 5.97386 6.50936V34.766H0.0251465V42.0112H63.9739V34.766H19.4031C19.7898 24.3183 28.6087 15.9282 39.4354 15.9282ZM55.1698 23.1735H50.5892V15.9282H56.4041L55.1698 23.1735ZM7.46104 6.50936C7.46104 5.30664 8.45745 4.33578 9.69181 4.33578H57.2816C58.5159 4.33578 59.5123 5.30664 59.5123 6.50936V12.3056C59.5123 13.5083 58.5159 14.4792 57.2816 14.4792H39.4354C27.7908 14.4792 18.3026 23.5213 17.9159 34.766H7.46104V6.50936ZM62.4867 36.215V40.5622H1.51233V36.215H62.4867Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSewing);
export default __webpack_public_path__ + "static/media/icon-sewing.db2bc2b4.svg";
export { ForwardRef as ReactComponent };